import React from 'react'
import LivePlanModify from '../../plan/LivePlanModify'
import V3PlanRouteShell from './V3PlanRouteShell'

export default function V3LivePlanModifyPage() {
  return (
    <V3PlanRouteShell>
      {React.createElement(LivePlanModify as any, { visualVariant: 'v3' })}
    </V3PlanRouteShell>
  )
}

